<script lang="ts">
	import { gameState, winner, gameStart } from '../stores/winState';
</script>

<footer>
	<button
		on:click={() => {
			$gameState = 'splash';
			$winner = false;
		}}
	>
		main</button
	>
	<button
		on:click={() => {
			$gameState = 'level';	
			$gameStart = false;
			$winner = false;
		}}
	>
		levels</button
	>
	<button> option</button>
</footer>

<style>
	footer {
		position: relative;
		display: flex;
		justify-content: space-evenly;
		align-items: center;
		top: 88%;
		background-color: #75c9b7;
		z-index: 100;
		height: 40px;
		overflow: hidden;
	}
	button {
		width: 100%;
		height: 100%;
		background-color: transparent;
		color: black;
		border: none;
		border: 2px solid white;
		margin: 0;
		padding: 0;
	}
</style>
